// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Input_componentWrapper__CIm-2","error":"Input_error__Ke2D8"};